import axios from 'axios';
import store from '../store';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_ROOT,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export default {
  getActiveSessions() {
    const token = store.getters.token;
    return apiClient.get('/stream/sessions', {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  joinSession(uid: number) {
    const token = store.getters.token;
    return apiClient.post(
      '/stream/join',
      { uid },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
  },
  leaveSession(uid: number) {
    const token = store.getters.token;
    return apiClient.post(
      '/stream/leave',
      { uid },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
  },
  startRecording(uid: number, latitude?: number, longitude?: number) {
    const token = store.getters.token;
    return apiClient.post(
      '/stream/record/start',
      { uid, latitude, longitude },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
  },
  stopRecording(streamRecordingId: number) {
    const token = store.getters.token;
    return apiClient.post(
      '/stream/record/stop',
      { streamRecordingId },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
  },
  getRecordingsForUid(uid: number) {
    const token = store.getters.token;
    return apiClient.get(`/stream/recordings?uid=${uid}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getRecordings() {
    const token = store.getters.token;
    return apiClient.get('/stream/recordings', {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getRecordingsForGroup(groupId: number) {
    const token = store.getters.token;
    return apiClient.get(`/stream/recordings?groupId=${groupId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getRecordingChunks(streamRecordingId: number) {
    const token = store.getters.token;
    return apiClient.get(`/stream/recordings/${streamRecordingId}/chunks`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  deleteRecording(streamRecordingId: number) {
    const token = store.getters.token;
    return apiClient.delete(`/stream/recordings/${streamRecordingId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  updateRecordingNotes(streamRecordingId: number, notes: string | null) {
    const token = store.getters.token;
    return apiClient.put(
      `/stream/recordings/${streamRecordingId}/notes`,
      { notes },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
  },
  createPassageFromRecording(
    streamRecordingId: number,
    passageTimestampUtc: string,
    latitude: number,
    longitude: number
  ) {
    const token = store.getters.token;
    return apiClient.post(
      '/stream/record/passage',
      { streamRecordingId, passageTimestampUtc, latitude, longitude },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
  },
};
